import { Box, Button, Checkbox, HStack, Input, Text } from '@chakra-ui/react';
import { Response } from '@core/components/Form/Form';
import { FormControl } from '@core/components/FormControl/FormControl';
import { getResponse } from '@waitroom/common-api';
import * as React from 'react';
import SocialAuth from '../../Social/Social';
import { RegisterFormProps } from './RegisterForm.types';
import { Terms } from './Terms/Terms';
import { useRegisterForm } from './useRegisterForm';

const buttonProps = { size: { base: 'sm', sm: 'def', md: 'md' } };
const buttonPropsSocial = { size: 'sm' };
const inputSize = { base: 'sm', sm: 'def' };
const RegisterForm = ({
  children,
  showResponse,
  onCompleted,
  withTerms = false,
  ...rest
}: RegisterFormProps): React.ReactElement | null => {
  const {
    t,
    methods: {
      register,
      handleSubmit,
      formState: { errors },
      setValue,
      watch,
    },
    submit,
    mutation,
  } = useRegisterForm(rest);

  return (
    <form data-id="Register" onSubmit={handleSubmit(submit)}>
      <Box mb={6}>
        <FormControl error={errors.email} label={t('global.workEmailAddress')}>
          <Input
            size={inputSize}
            placeholder={t('global.enterYourWorkEmail')}
            type="email"
            {...register('email')}
          />
        </FormControl>
        <HStack mt={4} spacing={4}>
          <FormControl error={errors.firstName} label={t('global.firstName')}>
            <Input
              size={inputSize}
              maxLength={100}
              placeholder={t('global.firstName')}
              {...register('firstName')}
            />
          </FormControl>
          <FormControl error={errors.lastName} label={t('global.lastName')}>
            <Input
              size={inputSize}
              maxLength={100}
              placeholder={t('global.lastName')}
              {...register('lastName')}
            />
          </FormControl>
        </HStack>
        {showResponse && mutation.error && Object.keys(errors).length === 0 ? (
          <Response mb={2} response={getResponse(mutation.error)} namespace="responses.register." />
        ) : null}
        {children}
      </Box>
      <Button
        w="100%"
        size={buttonProps.size}
        colorScheme="red"
        isLoading={mutation.isPending}
        type="submit"
        data-id="email-signup"
        id="submit-email-signup"
        onClick={(e) => {
          e.preventDefault();
          return handleSubmit(submit)();
        }}
      >
        {t('auth.signUpWithEmail')}
      </Button>
      <Text my={[4, 5, 6]} textAlign="center" fontSize="large" fontWeight="bold" color="gray.500">
        {t('global.OR')}
      </Text>
      <SocialAuth
        mb={4}
        onCompleted={onCompleted}
        redirectUrl={rest.redirectUrl}
        clientId={rest.clientId}
        state={rest.state}
        codeChallenge={rest.codeChallenge}
        buttonProps={buttonPropsSocial}
        isSignup={true}
      />
      <Box mt={8} textAlign="center">
        <Checkbox
          isChecked={watch('marketingOptIn')}
          onChange={(e) => {
            setValue('marketingOptIn', e.target.checked);
          }}
          mb={3}
          ml={2}
          alignItems="center"
        >
          {t('auth.agreeToEmails')}
        </Checkbox>
      </Box>
      {withTerms && <Terms mt={4} />}
    </form>
  );
};

export default RegisterForm;
